/** The founding table: co-founders start one company together. */
export const FOUNDING: Record<string, string> = {
	"A table has at most eight seats.": "Et bord har højst otte pladser.",
	"Add friend": "Tilføj ven",
	"At the table": "Ved bordet",
	"Back to your companies": "Tilbage til dine virksomheder",
	"ChatGPT not connected": "ChatGPT er ikke forbundet",
	"Close the table": "Luk bordet",
	"Close this table? {name} will not be started.": "Vil du lukke bordet? {name} bliver ikke startet.",
	"Connect ChatGPT": "Forbind ChatGPT",
	"Connect your ChatGPT account": "Forbind din ChatGPT-konto",
	"Connect your own ChatGPT account to be Ready": "Forbind din egen ChatGPT-konto for at blive klar",
	"Everyone at the table becomes a founder of {name}.": "Alle ved bordet bliver stiftere af {name}.",
	"Everyone is ready.": "Alle er klar.",
	"Friend request sent to {email}. Invite them here once they accept.":
		"Venneanmodning sendt til {email}. Inviter dem her, når de har sagt ja.",
	"I'm ready for the table as it is now": "Jeg er klar til bordet, som det er nu",
	"Invitations nobody has answered are withdrawn at Start.":
		"Invitationer, som ingen har svaret på, trækkes tilbage ved start.",
	Join: "Deltag",
	"Join the table": "Sæt dig ved bordet",
	"Leave the table": "Forlad bordet",
	"Leave the table for {name}?": "Vil du forlade bordet for {name}?",
	"Loading your friends": "Henter dine venner",
	"Not ready after all": "Alligevel ikke klar",
	"Not ready yet": "Ikke klar endnu",
	"Open {name}": "Åbn {name}",
	"Opening a table for {name}": "Åbner et bord til {name}",
	"Opening the table": "Åbner bordet",
	"Preparing {name}": "Gør {name} klar",
	"{name} could not be set up": "{name} kunne ikke sættes op",
	"Setting up {name} failed. It waits for us to set it up again; nothing you did caused it.":
		"Opsætningen af {name} mislykkedes. Den venter på, at vi sætter den op igen; det skyldes ikke noget, du har gjort.",
	"The Co-Founder has not started: no ChatGPT account could pay for its first run. Connect yours in Settings → AI subscriptions, then write to the Co-Founder in its thread.":
		"Co-Founderen er ikke gået i gang: ingen ChatGPT-konto kunne betale for dens første kørsel. Forbind din i Indstillinger → AI-abonnementer, og skriv så til Co-Founderen i dens tråd.",
	"The Co-Founder's first run did not start. Write to the Co-Founder in its thread to begin.":
		"Co-Founderens første kørsel startede ikke. Skriv til Co-Founderen i dens tråd for at gå i gang.",
	Ready: "Klar",
	"Ready ✓": "Klar ✓",
	"Remove {name} from the table?": "Vil du fjerne {name} fra bordet?",
	"See the table": "Se bordet",
	"Start {name}": "Start {name}",
	"Starting…": "Starter…",
	"The table changed while you were editing. Check it and try again.":
		"Bordet blev ændret, mens du redigerede. Se det igennem, og prøv igen.",
	"Their email address": "Deres e-mailadresse",
	"This table is no longer available to you.": "Du har ikke længere adgang til dette bord.",
	"To close the table, remove the other seats first.": "Fjern de andre pladser, før du lukker bordet.",
	"Waiting for {names} to be ready": "Venter på, at {names} bliver klar",
	"What is the company for? One line is enough to start.": "Hvad er virksomheden til? Én linje er nok til at starte.",
	"What the company is for": "Hvad virksomheden er til",
	"What will you do? Optional — one sentence is plenty.": "Hvad vil du lave? Valgfrit – én sætning er nok.",
	Withdraw: "Træk tilbage",
	"You are invited to start {company} together.": "Du er inviteret til at starte {company} sammen.",
	"You closed the table.": "Du lukkede bordet.",
	"You declined the invitation.": "Du takkede nej til invitationen.",
	"You left the table.": "Du forlod bordet.",
	"Your friends appear here. Add one below.": "Dine venner vises her. Tilføj en nedenfor.",
	"Your own account, connected to {name}. It pays for the work you start there. You can be Ready once it is connected.":
		"Din egen konto, forbundet til {name}. Den betaler for det arbejde, du sætter i gang der. Du kan blive klar, når den er forbundet.",
	"Your role": "Din rolle",
	"a founder": "en stifter",
	"{names} and {last}": "{names} og {last}",
	"{names} own it now.": "{names} ejer den nu.",
	"{name} has started": "{name} er startet",
	"{name} invited you to start {company} together.": "{name} har inviteret dig til at starte {company} sammen.",
	"{name} is starting": "{name} starter",
	"{name} owns it now.": "{name} ejer den nu.",
	"From idea to company.": "Fra idé til virksomhed.",
	"Tell your Co-Founder the idea. Friends can write it with you.":
		"Fortæl din Co-Founder idéen. Venner kan skrive den med dig.",
	"Your idea": "Din idé",
	"Your idea from qorpera.com": "Din idé fra qorpera.com",
	Start: "Start",
	"Invite friends": "Inviter venner",
	"What kind of company?": "Hvilken slags virksomhed?",
	Webshop: "Webshop",
	"A webshop with ceramics": "En webshop med keramik",
	"Marketing agency": "Marketingbureau",
	"A marketing agency": "Et marketingbureau",
	"Café and restaurant": "Café og restaurant",
	"A café with takeaway": "En café med takeaway",
	Consulting: "Rådgivning",
	"Sustainability consulting": "Bæredygtig rådgivning",
	Trades: "Håndværk",
	"A painting company in Aarhus": "Et malerfirma i Aarhus",
	"App or software": "App eller software",
	"An app for dog walkers": "En app til hundepassere",
	"They join as co-founders.": "De bliver medstiftere.",
	"Your first message to the Co-Founder. Write it together.":
		"Jeres første besked til Co-Founderen. Skriv den sammen.",
	"{names} are writing": "{names} skriver",
};
